"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isHeldExpired = isHeldExpired;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _NumberPicker = _interopRequireDefault(require("./NumberPicker"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus3"));
var _newTab = _interopRequireDefault(require("cccisd-icons/new-tab"));
var _enter = _interopRequireDefault(require("cccisd-icons/enter4"));
var _transmission = _interopRequireDefault(require("cccisd-icons/transmission"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _TransferForm = _interopRequireDefault(require("./TransferForm"));
var _style = _interopRequireDefault(require("./style.css"));
var _dateFns = require("date-fns");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
function isHeldExpired(heldLicense) {
  return (0, _get2["default"])(heldLicense, 'settings.defaultExpirationSelection') === 'date' && (0, _dateFns.isPast)((0, _dateFns.parse)((0, _get2["default"])(heldLicense, 'settings.defaultExpirationValueDate', '2099-01-01')));
}
var ManageGroupLicenseForm = function ManageGroupLicenseForm(_ref) {
  var _license$settings, _license$settings2, _license$settings3;
  var closeModal = _ref.closeModal,
    fetchData = _ref.fetchData,
    groupId = _ref.groupId,
    groupLabel = _ref.groupLabel,
    groupRandomHash = _ref.groupRandomHash,
    licenseData = _ref.licenseData,
    product = _ref.product,
    setIsAdminFormDirty = _ref.setIsAdminFormDirty,
    setIsReloadRequired = _ref.setIsReloadRequired;
  var license = licenseData.license,
    pawnCountWithLicense = licenseData.pawnCountWithLicense,
    pawnsNoLicense = licenseData.pawnsNoLicense,
    ancestorLicenses = licenseData.ancestorLicenses,
    transferFromOptions = licenseData.transferFromOptions;
  var savedExpirationDate = license === null || license === void 0 ? void 0 : (_license$settings = license.settings) === null || _license$settings === void 0 ? void 0 : _license$settings.defaultExpirationValueDate;
  var savedExpirationMonths = license === null || license === void 0 ? void 0 : (_license$settings2 = license.settings) === null || _license$settings2 === void 0 ? void 0 : _license$settings2.defaultExpirationValueMonths;
  var savedExpirationSelection = license === null || license === void 0 ? void 0 : (_license$settings3 = license.settings) === null || _license$settings3 === void 0 ? void 0 : _license$settings3.defaultExpirationSelection;
  var inheritableLicenses = ancestorLicenses.filter(function (lic) {
    return lic.inheritable && !isHeldExpired(lic);
  });
  var numAvailableNotInherited = 0;
  if (!isHeldExpired(license)) {
    numAvailableNotInherited = (license === null || license === void 0 ? void 0 : license.quantity) || 0;
  }
  var numAvailableInherited = inheritableLicenses.reduce(function (acc, curr) {
    return acc + curr.quantity;
  }, 0);
  var isAdmin = Fortress.hasAnyAccess(['licensing.admin', 'licensing.manage']);
  var initialAutoAssign = !!license.inheritable;
  var initialAdminQuantity = (license === null || license === void 0 ? void 0 : license.quantity) || 0;
  var initialExpirationDate = savedExpirationDate ? (0, _dateFns.parse)(savedExpirationDate) : null;
  var initialExpirationMonths = savedExpirationMonths ? savedExpirationMonths : product.durationMonths;
  var initialChecked = savedExpirationSelection ? savedExpirationSelection : 'duration';
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = (0, _react.useState)(initialAutoAssign),
    _useState4 = _slicedToArray(_useState3, 2),
    isAutoAssign = _useState4[0],
    setIsAutoAssign = _useState4[1];
  var _useState5 = (0, _react.useState)(initialAdminQuantity),
    _useState6 = _slicedToArray(_useState5, 2),
    adminQuantity = _useState6[0],
    setAdminQuantity = _useState6[1];
  var _useState7 = (0, _react.useState)(initialExpirationDate),
    _useState8 = _slicedToArray(_useState7, 2),
    expirationDate = _useState8[0],
    setExpirationDate = _useState8[1];
  var _useState9 = (0, _react.useState)(initialExpirationMonths),
    _useState10 = _slicedToArray(_useState9, 2),
    expirationDuration = _useState10[0],
    setExpirationDuration = _useState10[1];
  var _useState11 = (0, _react.useState)(initialChecked),
    _useState12 = _slicedToArray(_useState11, 2),
    checked = _useState12[0],
    setChecked = _useState12[1];
  (0, _react.useEffect)(function () {
    if (isAutoAssign !== initialAutoAssign || adminQuantity !== initialAdminQuantity || initialExpirationDate !== expirationDate || initialExpirationMonths !== expirationDuration || initialChecked !== checked) {
      setIsAdminFormDirty(true);
    }
  }, [isAutoAssign, adminQuantity, expirationDate, expirationDuration, checked]);
  function handleSubmit() {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var isDate, reqBody, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            isDate = checked === 'date' && checked !== '' && checked !== null;
            if (!(isAdmin && isDate && !expirationDate)) {
              _context.next = 6;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Validation Error: Cannot save license with no Expiration Date',
              type: 'danger'
            });
            setIsSubmitting(false);
            return _context.abrupt("return");
          case 6:
            if (!(isAdmin && isDate && (0, _dateFns.isPast)(expirationDate))) {
              _context.next = 10;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Validation Error: Expiration Date cannot be in the past',
              type: 'danger'
            });
            setIsSubmitting(false);
            return _context.abrupt("return");
          case 10:
            if (!(isAdmin && !isDate && !expirationDuration)) {
              _context.next = 14;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Validation Error: Cannot save license with no Expiration Duration',
              type: 'danger'
            });
            setIsSubmitting(false);
            return _context.abrupt("return");
          case 14:
            if (!(!isAdmin && !license.licenseId)) {
              _context.next = 18;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Error: Cannot save license with no licenseId',
              type: 'danger'
            });
            setIsSubmitting(false);
            return _context.abrupt("return");
          case 18:
            reqBody = {
              heldLicenseId: license.licenseId,
              inheritable: isAutoAssign
            };
            if (isAdmin) {
              reqBody.quantity = adminQuantity;
              reqBody.groupId = groupId;
              reqBody.productId = product.productId;
              reqBody.settings = _objectSpread(_objectSpread({}, license.settings), isDate ? {
                defaultExpirationValueDate: expirationDate.toISOString().substring(0, 10),
                defaultExpirationValueMonths: null,
                defaultExpirationSelection: checked
              } : {
                defaultExpirationValueDate: null,
                defaultExpirationValueMonths: expirationDuration,
                defaultExpirationSelection: checked
              });
            }
            if (!(isAdmin && !license.licenseId)) {
              _context.next = 26;
              break;
            }
            _context.next = 23;
            return _cccisdAxios["default"].post(Boilerplate.route('licensing.api.license.create'), reqBody);
          case 23:
            _context.t0 = _context.sent;
            _context.next = 29;
            break;
          case 26:
            _context.next = 28;
            return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.license.updateHeld', {
              license: license.licenseId
            }), reqBody);
          case 28:
            _context.t0 = _context.sent;
          case 29:
            response = _context.t0;
            if (response.data.status === 'error') {
              (0, _cccisdNotification["default"])({
                message: 'Failed to update license',
                data: response.data.errors,
                duration: 0,
                type: 'danger'
              });
            } else if (response.data.status === 'success') {
              (0, _cccisdNotification["default"])({
                message: 'Available Licenses updated successfully!',
                duration: 3000,
                type: 'success'
              });

              // If form is dirty, force a page refresh
              if (reqBody.inheritable !== (license === null || license === void 0 ? void 0 : license.inheritable)) {
                setIsReloadRequired(true);
              }
              setIsAdminFormDirty(false);
              closeModal();
            }
            setIsSubmitting(false);
          case 32:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  function renderTransfer() {
    var transferFromList = transferFromOptions.filter(function (g) {
      return g.groupId !== groupId && g.quantity > 0;
    });
    if (transferFromList.length <= 0 || !Fortress.hasAnyAccess(['licensing.group.transfer', 'licensing.child_group.transfer'])) {
      return;
    }
    var isDisabled = license && isHeldExpired(license);
    var trigger = /*#__PURE__*/_react["default"].createElement("button", {
      disabled: isDisabled,
      className: 'btn btn-xs btn-secondary ' + _style["default"].transferButton,
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement(_transmission["default"], null), "\xA0Transfer");
    var expiredTooltip = /*#__PURE__*/_react["default"].createElement("span", null, "License expiration for ", /*#__PURE__*/_react["default"].createElement("b", null, groupLabel), " has past. Must contact an administrator to transfer licenses.");
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      afterClose: function afterClose() {
        return fetchData();
      },
      title: "Transfer Licenses: ".concat(groupLabel, ": ").concat(product.label),
      trigger: isDisabled ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: expiredTooltip
      }, trigger) : trigger,
      triggerDisabled: isDisabled,
      render: function render(modalProps) {
        return /*#__PURE__*/_react["default"].createElement(_TransferForm["default"], _extends({}, modalProps, {
          productId: product.productId,
          transferToGroup: {
            groupId: groupId,
            label: groupLabel,
            quantity: license.quantity || 0,
            randomHash: groupRandomHash
          },
          transferFromList: transferFromList,
          setIsReloadRequired: setIsReloadRequired
        }));
      }
    });
  }
  function renderQuantity() {
    var totalLicenses = numAvailableNotInherited + numAvailableInherited;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, totalLicenses), " Available Licenses ", totalLicenses === 0 && renderTransfer(), totalLicenses > 0 && /*#__PURE__*/_react["default"].createElement("ul", {
      className: "list-unstyled"
    }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].listItemIcon
    }, /*#__PURE__*/_react["default"].createElement(_enter["default"], null)), "\xA0\xA0", numAvailableNotInherited, " belong to ", /*#__PURE__*/_react["default"].createElement("b", null, groupLabel), renderTransfer()), inheritableLicenses.map(function (lic) {
      return lic.quantity > 0 && /*#__PURE__*/_react["default"].createElement("li", {
        key: lic.licenseId
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].listItemIcon
      }, /*#__PURE__*/_react["default"].createElement(_enter["default"], null)), "\xA0\xA0", lic.quantity, " can be auto-assigned from ", /*#__PURE__*/_react["default"].createElement("b", null, lic.label));
    })));
  }
  function renderNumActiveLicenses() {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].numActiveLicenses
    }, /*#__PURE__*/_react["default"].createElement("b", null, pawnCountWithLicense), " License", pawnCountWithLicense === 1 ? '' : 's', " currently in use at", ' ', /*#__PURE__*/_react["default"].createElement("b", null, groupLabel));
  }
  function renderPawnNoLicense() {
    var labelMapper = {};
    pawnsNoLicense.forEach(function (r) {
      var roleDef = Appdefs.pawn.roles.find(function (role) {
        return r.role.handle === role.handle;
      });
      labelMapper[r.role.handle] = {
        one: roleDef.label,
        many: roleDef.labelPlural || roleDef.label + 's'
      };
    });
    var message = '';
    if (pawnsNoLicense.length === 0) {
      message = 'Users without a license';
    } else if (pawnsNoLicense.length === 1) {
      Object.keys(labelMapper).forEach(function (handle, i) {
        if (i === Object.keys(labelMapper).length - 1) {
          message += labelMapper[handle].one;
        } else if (i === Object.keys(labelMapper).length - 2) {
          message += labelMapper[handle].one + ' or ';
        } else {
          message += labelMapper[handle].one + ', ';
        }
      });
      message += ' without a license';
    } else {
      Object.keys(labelMapper).forEach(function (handle, i) {
        if (i === Object.keys(labelMapper).length - 1) {
          message += labelMapper[handle].many;
        } else if (i === Object.keys(labelMapper).length - 2) {
          message += labelMapper[handle].many + ' and ';
        } else {
          message += labelMapper[handle].many + ', ';
        }
      });
      message += ' without licenses';
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, pawnsNoLicense.length), " ", message);
  }
  function renderActionButton() {
    // if numAvailableNotInherited === 0, it shows in an alert style,
    // so margins are different

    if (product.purchaseUrl) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: numAvailableNotInherited ? '7px 0 21px 0' : '8px 0 0 0'
        }
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: product.purchaseUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: 'btn btn-xs ' + _style["default"].licenseButton,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), "\xA0Buy ", license.licenseId ? 'More' : 'Licenses')));
    }
    if (product.settings && product.settings.learnMoreUrl) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: numAvailableNotInherited ? '0 0 21px 0' : '5px 0 0 0'
        }
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: product.settings.learnMoreUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement(_newTab["default"], null), "\xA0Learn More"));
    }
    return null;
  }
  function renderAutoAssign() {
    // if no held license exists yet on this group
    if (!('quantity' in license)) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].autoAssign
    }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      label: /*#__PURE__*/_react["default"].createElement("span", null, "Automatically Assign", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tippyTitle
        }, /*#__PURE__*/_react["default"].createElement("h6", null, "Automatically Assign:"), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement("i", null, "Yes")), ' ', "means that all users within ", /*#__PURE__*/_react["default"].createElement("b", null, groupLabel), " can activate these licenses on a first-come-first-serve basis."), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement("i", null, "No")), ' ', "means that an administrator must decide which licenses are assigned to each user.")))
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-info"
      }, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_info["default"], null)))),
      value: isAutoAssign,
      onChange: function onChange() {
        return setIsAutoAssign(function (prev) {
          return !prev;
        });
      },
      name: "isAutoAssign"
    }));
  }
  function renderAdminArea() {
    var isExpireDatePast = checked === 'date' && expirationDate && (0, _dateFns.isPast)(expirationDate);
    var warnIcon = isExpireDatePast && /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-warning"
    }, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
      spaceRight: true,
      spaceLeft: true
    }), "Expired"));
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].admin
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].topExpiryWarning
    }, warnIcon), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
      title: "Admin"
    }, /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: function onSubmit(e) {
        return e.preventDefault();
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "add-licenses"
    }, isExpireDatePast ? 'Unused' : 'Set Available', " Licenses", isExpireDatePast && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("span", null, "Expiration date of ", expirationDate.toISOString().substring(0, 10), " has passed. No more licenses can be activated unless Expiration Rules are changed.")
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-info"
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
      spaceLeft: true
    })))), /*#__PURE__*/_react["default"].createElement(_NumberPicker["default"], {
      name: "add-licenses",
      onChange: setAdminQuantity,
      value: adminQuantity
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "set-expiration",
      style: {
        marginTop: '2em'
      }
    }, "Expiration Rules", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "This only affects future licenses."), " Any users with active licenses will keep their original expiration dates.")
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-info"
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
      spaceLeft: true
    })))), /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].radio
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      id: "duration",
      name: "expiration",
      value: "duration",
      checked: checked === 'duration',
      onClick: function onClick(e) {
        if (checked === 'duration') {
          setChecked(null);
        }
      },
      onChange: function onChange(e) {
        setChecked('duration');
      }
    }), "\xA0\xA0Each license will expire\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_NumberPicker["default"], {
      className: _style["default"].inline,
      disabled: checked !== 'duration',
      name: "duration",
      onChange: setExpirationDuration,
      value: expirationDuration
    }), "\xA0\xA0month(s) after activation."), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].radio
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      id: "date",
      name: "expiration",
      value: "date",
      onClick: function onClick(e) {
        if (checked === 'date') {
          setChecked(null);
        }
      },
      onChange: function onChange() {
        setChecked('date');
      },
      checked: checked === 'date'
    }), "\xA0\xA0All licenses will expire on\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
      className: 'form-control-sm ' + _style["default"].datePicker,
      disabled: checked !== 'date',
      name: "set-expiration",
      onChange: function onChange(e) {
        setExpirationDate(e);
      },
      selected: expirationDate,
      placeholderText: "mm/dd/yyyy"
    }), warnIcon)))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].licenseDetails, " ").concat(numAvailableNotInherited <= 0 ? 'alert alert-info' : '')
  }, renderQuantity(), renderNumActiveLicenses(), renderPawnNoLicense(), renderActionButton()), renderAutoAssign(), isAdmin && renderAdminArea(), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].btnContainer
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-secondary",
    type: "button",
    onClick: function onClick() {
      return closeModal();
    }
  }, "Close"), ('quantity' in license || isAdmin) && /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
    className: "btn btn-primary",
    title: "Save",
    isLoading: isSubmitting,
    onClick: handleSubmit
  })));
};
var _default = exports["default"] = ManageGroupLicenseForm;